import React from "react";

const BASE_WIDTH = 10;
const BASE_HEIGHT = 16;

interface OwnProps {
  width?: number;
  height?: number;
  rotation?: string | number;
  color?: string;
}
export default function ArrowIcon(props: OwnProps) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={`rotate(${props.rotation || 0})`}
    >
      {/* <path
        d="M23.2628 13.2998C23.6599 12.9026 23.6599 12.2588 23.2628 11.8616C22.8657 11.4645 22.2218 11.4645 21.8247 11.8616L15.2071 18.4792C14.8166 18.8697 14.8166 19.5029 15.2071 19.8934L21.8247 26.511C22.2218 26.9081 22.8657 26.9081 23.2628 26.511C23.6599 26.1139 23.6599 25.47 23.2628 25.0729L17.3763 19.1863L23.2628 13.2998Z"
        fill={props.color || "#4D4D4D"}
      /> */}
      <path
        d="M8.76281 2.04195C9.15994 1.64483 9.15994 1.00096 8.76281 0.603828V0.603828C8.36568 0.206701 7.72181 0.206701 7.32469 0.603828L0.707107 7.22141C0.316583 7.61193 0.316583 8.2451 0.707107 8.63562L7.32469 15.2532C7.72181 15.6503 8.36568 15.6503 8.76281 15.2532V15.2532C9.15994 14.8561 9.15994 14.2122 8.76281 13.8151L2.87625 7.92851L8.76281 2.04195Z"
        fill={props.color || "#4D4D4D"}
      />
    </svg>
  );
}
